<script setup>
const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
})

const { t } = useI18n()
</script>

<template>
  <div class="event">
    <div
      v-if="props.event?.date"
      class="equal-small-2 equal-small-2--bold event__date"
    >
      {{ props.event.date }}
    </div>
    <div
      v-if="props.event?.title"
      class="scale-1 scale-1--bold event__title"
    >
      {{ props.event.title }}
    </div>
    <div
      v-if="props.event?.description"
      class="equal-base"
    >
      {{ props.event.description }}
    </div>
    <NuxtLink
      v-if="props.event?.to"
      :to="props.event?.to"
      class="link link--animated event__link"
      :class="{
        'link--external': getTarget(props.event?.to) === '_blank',
      }"
      :target="getTarget(props.event?.to)"
    >
      {{ t('event.summary.moreInfos') }}
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';

.event {
  &__date {
    color: $color-disabled;
    margin-bottom: 5px;
  }

  &__title {
    margin-bottom: 18px;
  }

  &__link {
    margin-top: 15px;
  }
}
</style>
